(() => {
  const form = document.getElementById('ig-product-form');
  if (!form) return;

  const variantsEl = document.getElementById('ig-variants');
  const variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
  const idInput = form.querySelector('[data-variant-id]');
  const priceEl = form.querySelector('[data-price]');
  const cta = form.querySelector('[data-cta]');
  const ctaLabel = form.querySelector('[data-cta-label]');

  const readSelection = () => {
    const out = [];
    form.querySelectorAll('fieldset[data-option-position]').forEach((fs) => {
      const pos = Number(fs.dataset.optionPosition);
      const checked = fs.querySelector('input:checked');
      out[pos] = checked ? checked.value : null;
    });
    return out;
  };

  const updateVariant = () => {
    if (!variants.length) return;
    const sel = readSelection();
    const match = variants.find((v) => v.options.every((opt, i) => sel[i] === opt));
    if (!match) return;
    if (idInput) idInput.value = match.id;
    if (priceEl) priceEl.textContent = match.price;
    if (cta) cta.disabled = !match.available;
    if (ctaLabel) ctaLabel.textContent = match.available ? 'Add to bag' : 'Sold out';
  };

  form.addEventListener('change', updateVariant);

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (!cta || cta.disabled) return;
    const original = ctaLabel ? ctaLabel.textContent : '';
    cta.disabled = true;
    if (ctaLabel) ctaLabel.textContent = 'Adding';

    try {
      const fd = new FormData(form);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: fd,
        headers: { Accept: 'application/json' }
      });
      if (!res.ok) throw new Error('add failed');
      const cart = await fetch('/cart.js').then((r) => r.json());
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = `Bag (${cart.item_count})`;
      });
      if (ctaLabel) ctaLabel.textContent = 'Added';
      setTimeout(() => {
        if (ctaLabel) ctaLabel.textContent = original;
        cta.disabled = false;
      }, 1200);
    } catch (err) {
      if (ctaLabel) ctaLabel.textContent = 'Try again';
      setTimeout(() => {
        if (ctaLabel) ctaLabel.textContent = original;
        cta.disabled = false;
      }, 1400);
    }
  });
})();
